const html = require('choo/html')
const raw = require('choo/html/raw')
const { Button } = require('./elements.js')

module.exports = function Tutorial(state, emit) {
  if (!state.tutorialSteps || !state.tutorialSteps[0]) {
    return // Stop right there!
  }

  let tutorial = state.tutorialSteps[0]
  // target element this tutorial is poiting at
  let el = document.querySelector(tutorial.el)
  if (!el) {
    setTimeout(() => emit('render'))
    return
  }

  let message = html`
    <div class="message">
      <p>${raw(tutorial.message)}</p>
      <div class="controls">
        ${Button(
          { onClick: () => emit('canceltutorial') },
          'CANCEL'
        )}
        ${Button(
          { onClick: () => emit('nexttutorial') },
          state.tutorialSteps.length > 1 ? 'NEXT' : 'FINISH'
        )}
      </div>
    </div>
  `
  let hole = html`<div class="hole"></div>`
  let elBound = el.getBoundingClientRect()

  if (tutorial.position[0] == 'bottom') {
    message.style.top = `${elBound.bottom - 5}px`
  } else {
    message.style.top = `${elBound.top - 5}px`
  }
  if (tutorial.position[1] == 'left') {
    message.style.left = `${elBound.left - (window.innerWidth*0.2) - 10}px`
  } else {
    message.style.left = `${elBound.left + elBound.width + 10}px`
  }
  // Hole on the overlay
  hole.style.top = `${elBound.top - 5}px`
  hole.style.left = `${elBound.left - 5}px`
  hole.style.width = `${elBound.width + 10}px`
  hole.style.height = `${elBound.height + 10}px`

  return html`
    <div id="tutorial">
      ${message}
      ${hole}
    </div>
  `
}
